import { render, staticRenderFns } from "./templateView.vue?vue&type=template&id=08b64ca3&"
import script from "./templateView.vue?vue&type=script&lang=js&"
export * from "./templateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports